import {makeMainDispatchItems, makeNumbercheckbook} from "../helpers/main-dispatch-items.js";
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";

export default function MainDispatch({ title, data }) {
    const mainDispatch = makeMainDispatchItems(data);
    const numbercheckbook = makeNumbercheckbook(data);

    return (
        <div className="space-y-2">
            <div className="px-5">
                <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                    {title}
                </h2>
            </div>
            <InfoGrid items={numbercheckbook} columns={1} />
            <InfoGrid items={mainDispatch} columns={2} />
        </div>
    )
}